import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatOption, MatSelect, MatPrefix, MatSuffix } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { AlertLevel, AlertSearchFilter, AlertStatus } from '../../models/alerts';
import {
  ALERT_LEVELS,
  ALERT_LEVEL_META,
  ALERT_STATUS_META,
  ALERT_STATUSES,
  AlertLevelMeta,
  AlertStatusMeta
} from '../../models/alert-level.util';

@Component({
  selector: 'app-alert-filters',
  standalone: true,
  imports: [MatSelect, MatInput, MatFormField, MatIcon, MatPrefix, MatSuffix, MatOption, ReactiveFormsModule],
  templateUrl: './alert-filters.component.html',
  styleUrl: './alert-filters.component.scss'
})
export class AlertFiltersComponent {
  @Output() filterApplied = new EventEmitter<AlertSearchFilter | null>();

  readonly levels = ALERT_LEVELS;
  readonly statuses = ALERT_STATUSES;

  searchControl = new FormControl('', { nonNullable: true });
  selectedLevel: AlertLevel | '' = '';
  selectedStatus: AlertStatus | '' = '';

  search() {
    this.filterApplied.emit({
      message: this.searchControl.value || null,
      level: this.selectedLevel || null,
      status: this.selectedStatus || null
    });
  }

  clearSearch() {
    this.searchControl.setValue('');
    this.search();
  }

  levelMeta(level: AlertLevel): AlertLevelMeta {
    return ALERT_LEVEL_META[level];
  }

  statusMeta(status: AlertStatus): AlertStatusMeta {
    return ALERT_STATUS_META[status];
  }
}
